import React from "react";

import "./DeviceIcon.scss";

const typeToClassName = {
    cabinet: "device-type-cabinet",
    smartcabinet: "device-type-cabinet",
    encodingstation: "device-type-encoding-station",
    "logistics/pc": "device-type-logistics-pc",
    gatereader: "device-type-gate-reader",
    handheldreader: "device-type-handheld-reader",
    edgeserver: "device-type-edge-server",
    hammer: "device-type-hammer",
    forklift: "device-type-forklift",
    readingpoint: "device-type-reading-point",
    intelligentinventory:"device-type-intelligent-inventory",
};

/**
 * Forklift icon from
 * https://game-icons.net/1x1/delapouite/forklift.html licenced under CC BY 3.0
 */

export default class DeviceIcon extends React.PureComponent {
    render() {
        const props = this.props;

        const typeKey =  props.device &&  props.device.type && typeof props.device.type === "string" ? props.device.type.toLowerCase() : null;
        let typeClass = typeToClassName[typeKey] !== undefined ? typeToClassName[typeKey] : "device-type-unknown";
        if (typeClass === typeToClassName['smartcabinet']) {
            if(props.device && String(props.device.subType).includes('Freezer')){                
                typeClass = typeClass + '-freezer';
            }else if(props.device && (String(props.device.subType).includes('IF3') || String(props.device.subType).includes('IFG'))){
                typeClass = typeClass + '-if3'
            }
        }
        const sizeClass = props.small === true ? "small" : props.large ? "large" : "";

        if (typeClass === "device-type-unknown" && props.device && props.device.type && props.device.type !== null) {
            //console.log("Uknown device type:", props.device.type);

            return <span className={`device-icon ${sizeClass} device-type-unknown ${props.className}`} />;
        }

        return <span className={`device-icon ${sizeClass} ${typeClass} ${props.className}`} />;
    }
}
